import ADIColors from "@NA/Utils/ADIColors";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { filtersAccordionStyles } from "@insite/content-library/Widgets/ProductList/ProductListFiltersAccordion";
import { AccordionSectionHeader } from "@insite/mobius/AccordionSection";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";

import { css } from "styled-components";

filtersAccordionStyles.accordion = {
    css: css`
        padding-top: 0;        
            [class^="AccordionSectionHeader"] button {
            background-color: #fff;
            border: 0;
            border-top: 1px solid #ddd !important;
            padding: 17.5px 1px 13.5px 0 !important;

            :focus {
                outline: 0;
                border: 0 !important;
                border-top: 1px solid #ddd !important;
            }
            span {
                font-size: ${getProp("theme.typography.headerSecondary.size")};
                color: ${getColor("text.main")};
                font-weight: bold;
            }
            > div {
                span {
                    &:last-child {
                        color: ${ADIColors.gray25};
                        font-weight: 400;
                    }
                }
            }
        }
        
        [class^="AccordionSectionPanel"] {
            border: 0;
            padding: 2.5px 0 0 5px;
            max-height: 500px;
            ::-webkit-scrollbar {
                width: 8px;
                height: 5px;
                background-color: #fff;
            } 

            ::-webkit-scrollbar-thumb {
                background: #A0A0A0;
                border-radius: 5px;
            }
              ::-webkit-scrollbar-thumb:hover {
                background: #7F7F7F;
                border-radius: 5px;
            }    

            legend[class^="TypographyStyle"] {
                margin-bottom: 0;
            }
             
            span[role="checkbox"] + label {
                 margin-left: 8px;
                 margin-right: 4px;
            }

        }
        ${AccordionSectionHeader} {
            &:first-child {
                > Button {
                    border-top: 0 !important;
                }
            }
        }
    `,
};
